import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface AssignmentRow {
  id: string;
  user_id: string;
  user_email: string;
  server_id: string;
  server_name: string;
  db_name: string | null;
  created_at: string;
}

export function useAssignments(userId?: string) {
  const q = userId ? `?user_id=${userId}` : '';
  return useQuery({
    queryKey: ['assignments', userId ?? 'all'],
    queryFn: () => api<{ rows: AssignmentRow[] }>(`/assignments${q}`),
  });
}

export function useCreateAssignment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { user_id: string; server_id: string; db_name?: string | null }) =>
      api<{ id: string }>('/assignments', { method: 'POST', body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['assignments'] }),
  });
}

export function useDeleteAssignment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api(`/assignments/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['assignments'] }),
  });
}
